var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4858 1.7998H15.8778L10.6518 7.7733L16.8002 15.9003H11.9863L8.2163 10.9707L3.9016 15.9003H1.5083L7.0983 9.51075L1.2002 1.80045H6.1363L9.54425 6.30625L13.4858 1.7998ZM12.6467 14.469H13.972L5.4161 3.15635H3.9939L12.6467 14.469Z",
    fill: "#D6E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.140d1982109e66e049ecaee5d95c327e.svg";
export { ForwardRef as ReactComponent };